<template>
    <div class="photochooser__tab-content">
        <div class="d-flex align-items-center justify-content-center">

            <div class="row w-100">
                <div class="col-md-4 order-md-last">
                    <div class="w-100">
                        <multiselect
                                v-model="checkinSelected"
                                :placeholder="$t('photo_chooser.bought_multiselect_placeholder')"
                                track-by="picacode"
                                @input="inputChanged"
                                @search-change="inputChanged"
                                :options="checkins"
                                :custom-label="customLabel"
                                :show-labels="false">
                            <template slot="singleLabel" _slot-scope="props">
<!--                                <h1 style="font-size: 22px">{{ props.option.eventName }}</h1>-->
<!--                                <p>{{ props.option.eventDate|formatDate }}</p>-->
<!--                                <p>{{ props.option.picacode }}</p>-->
                                <span class="option__desc">{{ $t('photo_chooser.bought_multiselect_placeholder') }}</span>
                            </template>

                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <span class="option__title h6 m-0">{{ props.option.eventName }}</span>
                                    <span class="option__small font-weight-bold small text-secondary">{{ props.option.photoService }}</span>
                                    <div class="option__small _text-white"><span class="code">{{ props.option.picacode }}</span></div>
                                </div>
                            </template>

                            <span slot="noResult">{{ $t('photo_chooser.bought_multiselect_no_events_found') }}</span>
                        </multiselect>
                    </div>
                </div>

                <div class="col-md-8 order-md-first">
                    <div v-if="checkinSelected" class="photochooser__event-summary">
                        <h3 class="photochooser__event-summary__title">{{ checkinSelected.eventName }}</h3>
                        <div class="photochooser__event-summary__subtitle">{{ checkinSelected.eventDate|formatDate }}</div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="hasPhotos">
            <div class="mt-5" v-for="(photoIds, picacode) in photoIdsByPicacode" :key="picacode">
                <div class="row collage-photo">
                    <CollagePhotoItemPhotoChooser v-for="(photo, photoId) in getPhotosByIds(photoIds)" :key="photoId"
                                                  :photo="photo"
                                                  :selected="$parent.isSelected(photoId)"
                                                  :initially-selected="$parent.isInitiallySelected(photoId)"
                                                  :enable-zoom="false"
                                                  @zoom-clicked="showGallery(index)"
                                                  @photo-selected="$parent.selectPhoto(photo)"
                                                  @photo-unselected="$parent.unselectPhoto(photoId)"/>
                </div>
            </div>
        </template>

        <div class="mt-5 py-10 text-center" v-else-if="checkins.length > 0">
            <div class="col-12">
                <div class="h2">{{ $t('photo_chooser.no_printable_photos') }}</div>
            </div>
        </div>
    </div>
</template>


<script>
    import Multiselect from "vue-multiselect"
    // import CollagePhotoItem from '@/components/CollagePhotoItem'
    import CollagePhotoItemPhotoChooser from '@/components/CollagePhotoItemPhotoChooser'
    import EventService from "@/services/Event.js"

    export default {
        components: {
            Multiselect,
            // CollagePhotoItem,
            CollagePhotoItemPhotoChooser
        },

        props: ["photo", "selected", "initiallySelected"],

        data() {
            return {
                checkins: [],
                checkinSelected: null,
                photos: {},
                photoIdsByPicacode: {}
            }
        },

        created() {
            this.setCheckins()
            // let initialPicacode = this.$store.state.prints.photoChooserInitialPicaCode
            // if (initialPicacode) {
            //   this.checkinSelected = initialPicacode
            //   console.log('initialPicacode', initialPicacode)
            // }
        },

        computed: {
            hasPhotos() {
                return Object.keys(this.photoIdsByPicacode).length > 0
            }
        },

        methods: {
            // il valore ricercato viene confrontato con questa stringa
            customLabel({eventName, eventDate, picacode}) {
                return `${eventName} ${eventDate} ${picacode}`
            },

            inputChanged(value) {
                console.log('inputChanged', value)
                this.fetchBoughtPhotos(value.picaServiceId, value.picacode)
            },

            setCheckins() {
                // TODO: aggiungere isLoading = true
                let initialPicacode = this.$store.state.prints.photoChooserInitialPicaCode

                return EventService.getCheckinsWithPrintablePhotos()
                    .then(response => {
                        let options = []
                        for (let checkin of response.data.results) {
                            let option = {
                                picaServiceId: checkin.pica_service.id,
                                eventName: checkin.pica_service.event_name,
                                eventDate: checkin.pica_service.event_start_at,
                                eventPhotoService: checkin.pica_service.event_photo_service,
                                picacode: checkin.picacode
                            }
                            options.push(option)

                            if (initialPicacode === checkin.picacode) {
                                this.checkinSelected = option
                                this.inputChanged(option)
                            }
                        }
                        this.$set(this, "checkins", options)
                        // If no initial pica code has been set, we select the first checkin in the list
                        if (!initialPicacode && options) {
                            this.checkinSelected = this.checkins[0]
                            this.inputChanged(this.checkinSelected)
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                        return error
                    })
            },

            /*setPicaServices() {
                return EventService.getPicaServicesWithPrintablePhotos()
                    .then(response => {
                        let options = []
                        for (let picaService of response.data.results) {
                            options.push({
                                id: picaService.id,
                                eventName: picaService.event.name,
                                eventDate: picaService.event.start_at,
                                // picacode: 'dove lo pesco? devo avere prima i checkin dello user-.-'
                            })
                        }
                        this.$set(this, "picaServices", options)

                        console.warn("this.picaServices", this.picaServices)
                    })
                    .catch(function(error) {
                        console.log(error)
                        return error
                    })
            },*/

            fetchBoughtPhotos(picaServiceId, picacode) {
                // return EventService.getPicaServicePhotos(picaServiceId, picacode)
                return EventService.getMedias({picaServiceId, picacode, is_printable: true})
                    .then(response => {
                        let photos = {}
                        for (let item of response.data.results) {
                            photos[item.id] = item
                        }
                        this.photos = photos

                        //this.$set(this, "photos", response.data)
                        this.groupPhotosByPicacode()
                    })
            },

            groupPhotosByPicacode() {
                /*
                photoIdsByPicacode: {
                    'B5N601G0E': [5883112, 5889416]
                }
                */
                let obj = {}
                for (let photoId in this.photos) {
                    let photo = this.photos[photoId]

                    for (let picacode of photo['picacodes']) {
                        let code = picacode['code']

                        obj[code] = obj[code] || new Set()
                        obj[code].add(photoId)
                    }
                }
                this.$set(this, "photoIdsByPicacode", obj)
            },

            getPhotosByIds(photosIds) {
                return Object.keys(this.photos)
                    .filter(key => photosIds.has(key))
                    .reduce((obj, key) => {
                        obj[key] = this.photos[key]
                        return obj
                    }, {})
            },
        }
    }
</script>
